module.exports = __webpack_public_path__ + "img/v2-member.237a60df.png";